import React from 'react';

import { IconProps } from './type';

export function EyeSlashIcon({
  className = '',
  size = 24,
  ...props
}: React.ComponentProps<'svg'> & IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width={size}
      className={className}
      {...props}
    >
      <path d="M17.94 17.94A10.94 10.94 0 0 1 12 19c-7 0-11-7-11-7a21.77 21.77 0 0 1 5.06-5.94" />
      <path d="M1 1l22 22" />
      <path d="M9.88 9.88A3 3 0 0 0 12 15a3 3 0 0 0 2.12-.88" />
      <path d="M14.12 14.12 9.88 9.88" />
    </svg>
  );
}

export default EyeSlashIcon;
